var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "multiple-cards" },
    _vm._l(_vm.pair, function(info, j) {
      return _c(
        "div",
        {
          key: j,
          staticClass: "the-card",
          style: "border: 1px solid " + info.color
        },
        [
          _c(
            "div",
            {
              staticClass: "the-card-icon",
              style: "background: " + info.color
            },
            [
              _c(
                "span",
                { staticStyle: { "font-size": "2.5em", color: "White" } },
                [_c("i", { class: info.icon })]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "the-card-info" }, [
            info.value
              ? _c("div", { staticClass: "property load-up" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("\n          " + _vm._s(info.label) + "\n        ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "value" }, [
                    _c(
                      "span",
                      { staticClass: "number" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": info.value,
                            duration: 2600,
                            decimals: info.decimal ? info.numberOfDecimal : 0
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "unit" }, [
                      _vm._v(
                        "\n                      " +
                          _vm._s(info.unit) +
                          "\n                    "
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }